import { AutocompleteInput, Create, NumberInput, ReferenceInput, SelectInput, SimpleForm,  } from "react-admin";


export function ContestWinnerCreate(props) {

    return (
        <Create {...props}>
            <SimpleForm>
                <ReferenceInput source="contestId" reference="contest">
                    <SelectInput optionText="name"  />
                </ReferenceInput>

                <ReferenceInput source="childId" reference="child">
                    <SelectInput optionText="name"  />
                </ReferenceInput>

                <ReferenceInput source="submissionId" reference="contestSubmission">
                    <SelectInput optionText="id"  />
                </ReferenceInput>

                <NumberInput source="rank" />
            </SimpleForm>
        </Create>
    )
}